import {
  Optimizely,
  OptimizelyDecisionWithOutUserContext,
} from '@awaze/mfe-common.lib.optimizely'
import { OptimizelyState } from '../../context/optimizely-decisions-context'
import { getCookie } from '../helpers'
import { CORRELATION_ID_COOKIE_NAME } from 'src/constants'

export const getSpecificExperimentDecision = async (
  experimentKey: string,
  { dataFile = '', userId, userAgent, locale, brand, host }: OptimizelyState,
  additionalAttributes?: Record<string, string | number | boolean>,
): Promise<OptimizelyDecisionWithOutUserContext | null> => {
  if (!userId) {
    return null
  }
  const optimizelyInst = null

  const correlationId = getCookie(CORRELATION_ID_COOKIE_NAME)

  try {
    const optimizelyInst = await Optimizely.getInstance({
      dataFile: JSON.stringify(dataFile),
      eventBatchSize: 1,
      additionalConfig: {
        logLevel: 'ERROR',
      },
    })

    const optimizelyDecision = await optimizelyInst.getDecisions({
      experimentFlags: [experimentKey],
      userId,
      userAttributes: {
        application: 'search-mfe',
        brand,
        host,
        locale,
        isClientSide: true,
        ...(userAgent && { $opt_user_agent: userAgent, userAgent }),
        ...(additionalAttributes && { ...additionalAttributes }),
      },
    })

    return optimizelyDecision?.[experimentKey]
  } catch (error) {
    newrelic?.noticeError?.(error, correlationId ? { correlationId } : null)
    return null
  } finally {
    optimizelyInst?.close().catch((error) => {
      newrelic?.noticeError?.(error, correlationId ? { correlationId } : null)
    })
  }
}
